import { api } from "./api";

export const purchasesBillApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPurchasesBill: builder.query({
      query: () => "api/Purch",
      providesTags: ["purchasesBill"],
    }),
    getPurchasesBillByDoc: builder.query({
      query: (docID) => `api/Purch?DocNumver=${docID}`,
      providesTags: ["purchasesBill"],
    }),
    addPurchasesBill: builder.mutation({
      query: (formData) => ({
        url: "api/Purch",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["purchasesBill"],
    }),
    editPurchasesBill: builder.mutation({
      query: (formData) => ({
        url: "api/Purch",
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: ["purchasesBill"],
    }),
    deletePurchasesBill: builder.mutation({
      query: (docID) => ({
        url: `api/Purch?DocID=${docID}`,
        method: "DELETE",
      }),
      invalidatesTags: ["purchasesBill"],
    }),
  }),
});

export const {
  useGetPurchasesBillQuery,
  useLazyGetPurchasesBillByDocQuery,
  useAddPurchasesBillMutation,
  useEditPurchasesBillMutation,
  useDeletePurchasesBillMutation,
} = purchasesBillApi;
